import React, { useState, useEffect, useRef } from 'react';
import ReactSelect from 'react-select';
import { connect } from 'react-redux';
import * as homeActions from '../../../redux/homeActions';
import * as fabricCanvasActions from '../../../redux/fabricCanvasActions';
import * as finalCheckActions from '../../../redux/finalCheckActions';
import * as sideBarActions from '../../../redux/sideBarActions';
import { bindActionCreators } from 'redux';
import '../SideBarContainer.scss';
import { string } from '../../../localization';
import { Button, Input } from 'reactstrap';
import * as Constants from '../../../utilities/constants/Constants';
import { Icons } from '../../../utilities/Icons/Icons';
import {
  convertImperialToGivenUnitSystem,
  isSignageSuiteProduct
} from '../../../utilities/HelperFunctions/HelperFunctions';
import { getUnit } from '../../../redux/homeActions';
import * as validationActions from '../../../validationFile/ValidationFile';
import * as sizeHandler from '../../../redux/actions/sizeHandler';

const settingsTemplate = props => {
  const {
    dispatchers,
    language,
    supportedViewingDistances,
    unitSystem,
    productSizes,
    displaySize,
    projectWidth,
    projectHeight,
    customWall,
    orientation,
    multiWallProjects,
    selectedDefaultSize,
    project,
    multiCanvas,
    canvasWall
  } = props;

  const {
    canvasWallWidthInput,
    canvasWallHeightInput,
    canvasWallWidthValid,
    canvasWallHeightValid,
    canvasWallActiveErrorMessage,
    canvasWallWidthErrorMessage,
    canvasWallHeightErrorMessage
  } = canvasWall;

  const [isCustom, setIsCustom] = useState(false);
  const [widthInputValue, setWidthInputValue] = useState(0);
  const [heightInputValue, setHeightInputValue] = useState(0);
  const [isLightContrast, setIsLightContrast] = useState(false);
  const [dropDownSize, setDropDownSize] = useState(0);
  const [dropDownViewingDistance, setDropDownViewingDistance] = useState(null);
  const [multiCanvasRow, setMultiCanvasRow] = useState(0);
  const [multiCanvasColumn, setMultiCanvasColumn] = useState(0);
  const [wallWidthInput, setWallWidthInput] = useState(0);
  const [wallHeightInput, setWallHeightInput] = useState(0);

  const reactSelectRef = useRef(null);
  const {
    rowInput,
    columnInput,
    rowValid,
    columnValid,
    multiCanvasErrorMessage,
    rowErrorMessage,
    colErrorMessage
  } = multiCanvas;

  let message = multiCanvasErrorMessage;
  if (message == '') {
    message = rowErrorMessage != '' ? rowErrorMessage : colErrorMessage;
  }

  useEffect(() => {
    updateProjectSizeUI();
    setDropDownViewingDistance(project.targetViewingDistance);
  }, []);

  useEffect(() => {
    updateProjectSizeUI();
  }, [customWall, selectedDefaultSize, unitSystem]);

  useEffect(() => {
    if (multiWallProjects.length > 1) {
      if (reactSelectRef.current) {
        reactSelectRef.current.onChange({ value: 'custom' });
      }
    }
  }, [multiWallProjects]);

  const updateProjectSizeUI = () => {
    if (selectedDefaultSize != 'custom') {
      setDropDownSize(selectedDefaultSize);
      setIsCustom(false);
    } else {
      setDropDownSize('custom');
      setIsCustom(true);
    }
    const widthInCurrentUnitSystem = convertImperialToGivenUnitSystem(
      customWall.customWidth,
      unitSystem
    );
    const heightInCurrentUnitSystem = convertImperialToGivenUnitSystem(
      customWall.customHeight,
      unitSystem
    );
    setWidthInputValue(widthInCurrentUnitSystem);
    setHeightInputValue(heightInCurrentUnitSystem);

    const canvasWallWidthInCurrentUnitSystem = convertImperialToGivenUnitSystem(
      canvasWallWidthInput,
      unitSystem
    );
    const canvasWallHeightInCurrentUnitSystem = convertImperialToGivenUnitSystem(
      canvasWallHeightInput,
      unitSystem
    );
    setWallWidthInput(canvasWallWidthInCurrentUnitSystem);
    setWallHeightInput(canvasWallHeightInCurrentUnitSystem);

    setMultiCanvasRow(rowInput);
    setMultiCanvasColumn(columnInput);
  };

  const handleOrietation = () => {
    const oldWidth = widthInputValue;
    const oldHeight = heightInputValue;
    setWidthInputValue(oldHeight);
    setHeightInputValue(oldWidth);

    dispatchers.homeActions.changeOrientation();
  };

  const handleMinimumDistanceChange = e => {
    dispatchers.fabricCanvasActions.makeProjectDirtyWithNoUndoSupport(true);
    dispatchers.finalCheckActions.changeMinimumViewingDistance(e.distance);
    dispatchers.fabricCanvasActions.minimumViewingDistanceIsUpdated();
    setDropDownViewingDistance(e.distance);
  };

  const changeContrastHandler = () => {
    setIsLightContrast(!isLightContrast);
    dispatchers.homeActions.changeContrast();
  };

  const filterLanguages = () => {
    const { supportedLanguages, isVanilla } = props;

    const languages = supportedLanguages;
    const languagesArray = [];

    Object.keys(languages).forEach(key => {
      const newDict = {};

      if (isVanilla) {
        Constants.VANILLA_SUPPORTED_LANGUAGES.forEach(lan => {
          if (lan === languages[key]) {
            newDict.value = languages[key];
            newDict.label = string[key];
            languagesArray.push(newDict);
          }
        });
      } else {
        newDict.value = languages[key];
        newDict.label = string[key];
        languagesArray.push(newDict);
      }
    });
    return languagesArray;
  };

  const setCustomWidth = e => {
    setWidthInputValue(e.target.value);
    dispatchers.sizeHandler.customWidthChange(e.target.value);
  };

  const setCustomHeight = e => {
    setHeightInputValue(e.target.value);
    dispatchers.sizeHandler.customHeightChange(e.target.value);
  };

  const {
    widthValid,
    heightValid,
    widthErrorMessage,
    heightErrorMessage,
    activeErrorMessage
  } = customWall;

  let errorMessage = activeErrorMessage;
  if (errorMessage == '') {
    errorMessage =
      widthErrorMessage != '' ? widthErrorMessage : heightErrorMessage;
  }

  const defaultSelectedLanguage = filterLanguages().filter(
    f => f.value === language
  );
  const distanceArray = [];
  const unit = getUnit(unitSystem);
  supportedViewingDistances.forEach((distance, index) => {
    const distanceDictionary = {};
    let displayString = '';
    if (index === 0) {
      displayString = `${
        string.CLOSE_UP_KEY
      }( ${convertImperialToGivenUnitSystem(distance, unitSystem)}${unit} )`;
    } else if (index === 1) {
      displayString = `${string.NEAR_KEY}( ${convertImperialToGivenUnitSystem(
        distance,
        unitSystem
      )}${unit} )`;
    } else if (index === 2) {
      displayString = `${string.FAR_KEY}( ${convertImperialToGivenUnitSystem(
        distance,
        unitSystem
      )}${unit} )`;
    }
    distanceDictionary.value = distance.toString();
    distanceDictionary.label = displayString;
    distanceDictionary.distance = distance;
    distanceArray.push(distanceDictionary);
  });
  const defaultSelectedDistance = distanceArray.filter(
    f => f.distance === dropDownViewingDistance
  );

  const allSizes = [...productSizes.default.sizes];
  if (productSizes.custom.sizes) {
    const item = {
      id: 'custom',
      name: string.CUSTOM_KEY,
      width: '',
      height: ''
    };
    allSizes.push(item);
  }

  const sizeArray = allSizes.map((item, index) => {
    if (item.id === 'custom') {
      return {
        value: item.id,
        label: item.name
      };
    }
    let sizeString = '';
    if (displaySize != Constants.DIMENSION) {
      sizeString = item.name;
    }
    sizeString += ' ';
    if (displaySize !== Constants.NAME) {
      sizeString += `${sizeHandler.unitConverter(
        item,
        'width',
        unitSystem
      )} x ${sizeHandler.unitConverter(item, 'height', unitSystem)} ${getUnit(
        unitSystem
      )}`;
    }
    return {
      value: index,
      label: sizeString,
      isdisabled: multiWallProjects.length > 1
    };
  });

  const handleRowChange = val => {
    setMultiCanvasRow(val);
    dispatchers.sizeHandler.rowChange(val);
  };

  const handleColumnChange = val => {
    setMultiCanvasColumn(val);
    dispatchers.sizeHandler.columnChange(val);
  };

  const handleCanvasWallWidthChange = val => {
    setWallWidthInput(val);
    dispatchers.sizeHandler.canvasWallWidthChange(val);
  };

  const handleCanvasWallHeightChange = val => {
    setWallHeightInput(val);
    dispatchers.sizeHandler.canvasWallHeightChange(val);
  };

  const showCross = () => (
    <span style={{ width: '50px', marginTop: '18px' }}> X </span>
  );

  const selectedSizeItem = sizeArray.filter(f => f.value == dropDownSize)[0];

  let canvasWallErrorMessage = canvasWallActiveErrorMessage;
  if (canvasWallErrorMessage == '') {
    canvasWallErrorMessage =
      canvasWallWidthErrorMessage != ''
        ? canvasWallWidthErrorMessage
        : canvasWallHeightErrorMessage;
  }

  // React-select components
  return (
    <div className='d-flex flex-column setting-tab theme-wrapper-scroll-bar'>
      <div
        className='d-flex flex-column'
        style={{
          flex: 1,
          margin: '24px 18px 20px 18px',
          font: '12px/14px HPSimplifiedLight, Arial, sans-serif'
        }}
      >
        <div className='theme-wrapper-setting' style={{ color: 'white' }}>
          {/* Resize */}

          {dispatchers.validationActions.shouldShowResizeField() ? (
            <div>
              <h6 className=' d-flex arrow-cursor text-align-left mb-3'>
                {string.RESIZE_KEY}
              </h6>
              <ReactSelect
                className='border border-secondary mt-3'
                name='wallSelect'
                value={selectedSizeItem}
                options={sizeArray}
                isOptionDisabled={option => option.isdisabled}
                ref={reactSelectRef}
                styles={{
                  control: base => ({
                    ...base,
                    '&:hover': { borderColor: 'gray' },
                    border: '1px solid rgb(128, 128, 128)',
                    borderRadius: '0px',
                    boxShadow: 'none',
                    background: 'none',
                    color: '#000',
                    cursor: 'pointer'
                  }),
                  option: provided => ({
                    ...provided,
                    color: '#000',
                    padding: '5px'
                  }),
                  singleValue: base => ({
                    ...base,
                    color: 'white'
                  })
                }}
                onChange={e => {
                  if (e.value === 'custom') {
                    setDropDownSize(e.value);
                    setIsCustom(true);
                    dispatchers.homeActions.setCustomWallSize(
                      projectWidth,
                      projectHeight
                    );
                    dispatchers.homeActions.sizeDropdownIsChanged(e.value);
                  } else {
                    setDropDownSize(e.value);
                    setIsCustom(false);
                    dispatchers.homeActions.settingsWallChange(e.value);
                  }
                }}
              />
              {isCustom ? (
                <div
                  style={{
                    marginLeft: '0px',
                    marginTop: '21px',
                    display: 'inline-flex',
                    flexDirection: 'column'
                  }}
                >
                  <div
                    style={{
                      display: 'flex'
                    }}
                  >
                    <div className='custom-width-input-settings'>
                      <Input
                        className={widthValid}
                        type='number'
                        bsSize='lg'
                        placeholder={widthInputValue}
                        value={widthInputValue}
                        onChange={e => {
                          setCustomWidth(e);
                        }}
                        onClick={e => e.target.select()}
                        onKeyPress={e => {
                          if (e.key === 'Enter') {
                            dispatchers.homeActions.settingsWallChange(
                              'custom'
                            );
                          }
                        }}
                      />
                    </div>

                    <span style={{ width: '50px', marginTop: '18px' }}>
                      {' '}
                      X{' '}
                    </span>

                    <div className='custom-width-input-settings'>
                      <Input
                        className={heightValid}
                        type='number'
                        bsSize='lg'
                        placeholder={heightInputValue}
                        value={heightInputValue}
                        onChange={e => {
                          setCustomHeight(e);
                        }}
                        onClick={e => e.target.select()}
                        onKeyPress={e => {
                          if (e.key === 'Enter') {
                            dispatchers.homeActions.settingsWallChange(
                              'custom'
                            );
                          }
                        }}
                        disabled={multiWallProjects.length > 1}
                      />
                    </div>
                  </div>
                  <div className='d-block error-message-custom-feilds'>
                    {errorMessage}
                  </div>
                  {multiWallProjects.length > 1 ? (
                    <div className='project-size-warning'>
                      No height variation is allowed. All walls will have same
                      height.
                    </div>
                  ) : null}

                  <Button className='d-none' />
                </div>
              ) : null}
            </div>
          ) : null}

          {/* Rows and Columns */}

          {dispatchers.validationActions.shouldShowRowColumnField() ? (
            <>
              {' '}
              <hr className='horizontalBorder' />
              <h6 className=' d-flex text-align-left  mb-3'>
                {string.ROWS_COLUMN_LABEL_STRING_KEY}
              </h6>
              <div className='d-flex'>
                <div className='custom-width-input-settings'>
                  <Input
                    bsSize='lg'
                    type='number'
                    value={multiCanvasRow}
                    className={rowValid}
                    onChange={e => handleRowChange(e.target.value)}
                  />
                </div>
                {showCross()}
                <div className='custom-width-input-settings'>
                  <Input
                    bsSize='lg'
                    type='number'
                    value={multiCanvasColumn}
                    className={columnValid}
                    onChange={e => handleColumnChange(e.target.value)}
                  />
                </div>
              </div>
              <div className='error-message-custom-feilds'>{message}</div>
            </>
          ) : null}

          {/* Wall Size */}

          {dispatchers.validationActions.shouldShowWallSizeField() ? (
            <>
              {' '}
              <hr className='horizontalBorder' />
              <h6 className=' d-flex text-align-left  mb-3'>
                {string.WALL_SIZE_TEXT_KEY}
              </h6>
              <div className='d-flex'>
                <div className='custom-width-input-settings'>
                  <Input
                    bsSize='lg'
                    type='number'
                    className={canvasWallWidthValid}
                    value={wallWidthInput}
                    onChange={e => handleCanvasWallWidthChange(e.target.value)}
                  />
                </div>
                {showCross()}
                <div className='custom-width-input-settings'>
                  <Input
                    bsSize='lg'
                    type='number'
                    className={canvasWallHeightValid}
                    value={wallHeightInput}
                    onChange={e => handleCanvasWallHeightChange(e.target.value)}
                  />
                </div>
              </div>
              <div className='error-message-custom-feilds'>
                {canvasWallErrorMessage}
              </div>
            </>
          ) : null}

          {/* Orientation */}

          {dispatchers.validationActions.shouldShowOrientationField() ? (
            <div>
              <hr className='horizontalBorder' />
              <div className='justify-content-start '>
                <h6 className=' d-flex text-align-left arrow-cursor mb-3'>
                  {string.ORIENTATION_KEY}
                </h6>
                <div className='d-flex'>
                  <div className='d-flex input-group pt-20 pl-1'>
                    <input
                      type='radio'
                      name='radioButtonSet'
                      value='input1'
                      onChange={handleOrietation}
                      checked={orientation === 'Landscape'}
                      style={{ marginTop: '3px' }}
                    />
                    <label htmlFor='landscape' className='settings-label-1'>
                      {string.LANDSCAPE_KEY}
                    </label>
                  </div>
                  <div className='d-flex input-group pt-20'>
                    <input
                      type='radio'
                      name='radioButtonSet'
                      value='input2'
                      onChange={handleOrietation}
                      checked={orientation !== 'Landscape'}
                      style={{ marginTop: '3px' }}
                    />
                    <label htmlFor='portrait' className='settings-label-1'>
                      {string.PORTRAIT_KEY}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
          {/* Measurement */}

          {dispatchers.validationActions.shouldShowMeasurementField() ? (
            <div>
              {!isSignageSuiteProduct() ? (
                <hr className='horizontalBorder' />
              ) : null}
              <div className='justify-content-start '>
                <h6 className=' d-flex text-align-left arrow-cursor mb-3'>
                  {string.MEASUREMENT_KEY}
                </h6>
                <div className='d-flex'>
                  <div className='d-flex input-group pt-20 pl-1'>
                    <input
                      id='input3'
                      type='radio'
                      name='radioButtonSet1'
                      style={{ marginTop: '3px' }}
                      onChange={() => {
                        if (isCustom) {
                          setWidthInputValue(
                            convertImperialToGivenUnitSystem(
                              projectWidth,
                              Constants.IMPERIAL_KEY
                            )
                          );
                          setHeightInputValue(
                            convertImperialToGivenUnitSystem(
                              projectHeight,
                              Constants.IMPERIAL_KEY
                            )
                          );
                        }
                        dispatchers.homeActions.toggleUnitSystem();
                      }}
                      checked={unitSystem === Constants.METRIC_KEY}
                    />
                    <label
                      htmlFor='metric'
                      className='settings-label-1 unit-sytem-label'
                    >
                      {string.METRIC_KEY}({string.PLACEHOLDER_CM_STRING_KEY})
                    </label>
                  </div>
                  <div className='d-flex input-group pt-20 pl-1'>
                    <input
                      id='input4'
                      type='radio'
                      name='radioButtonSet1'
                      style={{ marginTop: '3px' }}
                      onChange={() => {
                        if (isCustom) {
                          setWidthInputValue(
                            convertImperialToGivenUnitSystem(
                              projectWidth,
                              Constants.METRIC_KEY
                            )
                          );
                          setHeightInputValue(
                            convertImperialToGivenUnitSystem(
                              projectHeight,
                              Constants.METRIC_KEY
                            )
                          );
                        }
                        dispatchers.homeActions.toggleUnitSystem();
                      }}
                      checked={unitSystem === Constants.IMPERIAL_KEY}
                    />
                    <label
                      htmlFor='inches'
                      className='settings-label-1 unit-sytem-label'
                    >
                      {string.IMPERIAL_KEY}(
                      {string.PLACEHOLDER_INCHES_STRING_KEY})
                    </label>
                  </div>
                </div>
              </div>
            </div>
          ) : null}

          {/* Background Contrast */}
          {dispatchers.validationActions.shouldShowBackgroundContrastField() ? (
            <div>
              <hr className='horizontalBorder' />
              <div className='background-contrast'>
                <button
                  type='button'
                  style={{
                    border: 'none',
                    background: 'none',
                    outline: 'none'
                  }}
                  onClick={changeContrastHandler}
                >
                  <img
                    src={
                      isLightContrast
                        ? Icons.darkContrast
                        : Icons.light_contrast
                    }
                    className='rounded float-left'
                    alt=''
                  />
                </button>
                <label htmlFor='contrast'>
                  {string.BACKGROUND_CONTRAST_KEY}
                </label>
              </div>
            </div>
          ) : null}

          {/* Language */}
          {dispatchers.validationActions.shouldShowLanguageField() ? (
            <div>
              <hr className='horizontalBorder' />
              <div
                className='justify-content-start '
                style={{ color: 'white' }}
              >
                <h6 className=' d-flex text-align-left arrow-cursor mb-3'>
                  {string.LANGUAGE_LABLE_KEY}
                </h6>
                <ReactSelect
                  id='react-select-shadow-dropdown'
                  value={defaultSelectedLanguage}
                  options={filterLanguages()}
                  onChange={e =>
                    dispatchers.homeActions.settingsLanguagChange(e)
                  }
                  styles={{
                    control: base => ({
                      ...base,
                      '&:hover': { borderColor: 'gray' },
                      border: '1px solid rgb(128, 128, 128)',
                      borderRadius: '0px',
                      boxShadow: 'none',
                      background: 'none',
                      color: '#000',
                      cursor: 'pointer'
                    }),
                    option: provided => ({
                      ...provided,
                      color: '#000',
                      padding: '5px'
                    }),
                    singleValue: base => ({
                      ...base,
                      color: 'white',
                      fontWeight: 'bold'
                    }),
                    menuList: base => ({
                      ...base,
                      height: '200px'
                    })
                  }}
                />
              </div>
            </div>
          ) : null}

          {/* Pixelation Warning */}
          {dispatchers.validationActions.shouldShowPixelationWarningField() ? (
            <div>
              <hr className='horizontalBorder' />
              <div className='justify-content-start '>
                <h6 className=' d-flex text-align-left arrow-cursor mb-3'>
                  {string.PIXELATION_WARNING_SETTINGS_KEY}
                </h6>
                <ReactSelect
                  id='react-select-font-family'
                  value={defaultSelectedDistance}
                  options={distanceArray}
                  onChange={e => handleMinimumDistanceChange(e)}
                  // components={{}}
                  styles={{
                    control: base => ({
                      ...base,
                      '&:hover': { borderColor: 'gray' },
                      border: '1px solid rgb(128, 128, 128)',
                      borderRadius: '0px',
                      boxShadow: 'none',
                      background: 'none',
                      color: '#000',
                      cursor: 'pointer'
                    }),
                    option: provided => ({
                      ...provided,
                      color: '#000',
                      padding: '5px'
                    }),
                    singleValue: base => ({
                      ...base,
                      color: 'white',
                      fontWeight: 'bold'
                    })
                  }}
                />
                <h6 className=' d-flex text-align-left arrow-cursor mt-2'>
                  {string.MINIMUM_VIEWING_DISTANCE_KEY}
                </h6>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    productSizes: state.modal.productSizes,
    selectedDefaultSize: state.home.selectedDefaultSize,
    projectWidth: state.home.projectWidth,
    projectHeight: state.home.projectHeight,
    supportedLanguages: state.modal.envData.supported_languages,
    language: state.home.language,
    orientation: state.home.orientation,
    unitSystem: state.home.unitSystem,
    supportedViewingDistances: state.modal.envData.supported_viewing_distances,
    project: state.finalCheck.project,
    displaySize: state.modal.storeData.displaySize,
    customWall: state.home.customWall,
    isVanilla: state.modal.envData.is_vanilla_designer,
    multiWallProjects: state.finalCheck.multiWallProjects,
    multiCanvas: state.home.multiCanvas,
    canvasWall: state.home.canvasWall
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      homeActions: bindActionCreators(homeActions, dispatch),
      fabricCanvasActions: bindActionCreators(fabricCanvasActions, dispatch),
      sideBarActions: bindActionCreators(sideBarActions, dispatch),
      finalCheckActions: bindActionCreators(finalCheckActions, dispatch),
      validationActions: bindActionCreators(validationActions, dispatch),
      sizeHandler: bindActionCreators(sizeHandler, dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(settingsTemplate);
